import React, { useEffect, useRef, useState } from "react"
import { FetchHandler } from "../../Handlers/FetchHandler";
import { MessageBoxes } from "../../Handlers/MessageBoxes";
import { usePlant } from "../../hooks/usePlant";
import { SelectPlantsDialog } from "../Dialogs/SelectPlantsDialog";
import { EditCheckbox, EditDateKeyInput, EditNumberInput, EditSelectInput, EditStringInput, EditViewsClicks } from "../FormComponents/EditInput";
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon";
import { Dialog } from "../Shared/Dialog";
import { ThreeColumnContainer } from "../Shared/Formelements";
import { TagSelector } from "../Shared/TagSelector";
import { ToolBar, ToolBarClean, ToolbarItemType } from "../ToolBar/ToolBar";
import { ScreenHeader } from "../UI/Elements"
import { Overlay } from "../UI/Overlay"
import { AdItemStatisticsType, AdItemType, AdItemTypeType, AdProjectType, AdStateType } from "./AdTypes";
import { useAdAdmin, useAdClients, useAdItemEditor } from "./useAdAdmin";
import { DateFormatter } from "../../Handlers/Helpers";
import { UploadImageToAdElement } from "../FormComponents/UploadImageElement";
import { useDateHelper } from "../../hooks/useHelper";

export const AdAdmin = () => {

    // Ensure clients
    const uiClients = useAdClients();
    useEffect(() => { uiClients.load(); }, []);

    const [selectedState, setSelectedState] = useState<AdStateType | "all">("all");


    const ui = useAdAdmin();

    useEffect(() => {
        //ui.load();
        ui.loadWithState(selectedState);
    }, [, selectedState]);

    const [showAddAd, setShowAddAd] = useState<boolean>(false);
    const [showAddAdProject, setShowAddAdProject] = useState<boolean>(false);
    const onAddAd = () => {
        setShowAddAd(true);
    }
    const onAddAdProject = () => {
        setShowAddAdProject(true);
    }

    const [selectedId, setSelectedId] = useState<string>(null);

    const tools = [
        { id: "0", label: "Lägg till projekt", onClick: onAddAdProject, icon: AdminIcons.plus },
        // { id: "1", label: "Lägg till annons", onClick: onAddAd, icon: AdminIcons.plus },
        // {
        //     id: "3",
        //     label: selectedState == "archived" ? "Visar arkiverade" : "Visar inte arkiverade",
        //     onClick: () => setSelectedState(selectedState == "archived" ? "all" : "archived"),
        //     icon: selectedState == "archived" ? AdminIcons.eye : AdminIcons.eyeclosed
        // },
    ];

    const [adStates, setAdStates] = useState<AdStateType[]>(["active", "draft", "for_review"]);
    const toggleAdStates = (e: AdStateType | undefined) => {
        if (adStates?.indexOf(e) >= 0) {
            setAdStates(adStates.filter(n => n != e));
        } else {
            setAdStates([...adStates, e]);
        }
    }

    const state_tools: ToolbarItemType[] = [
        { id: "all", label: "active + draft + for_review", onClick: () => setSelectedState("all"), selected: selectedState === "all" },
        { id: "draft", label: "draft", onClick: () => setSelectedState("draft"), selected: selectedState === "draft" },
        { id: "for_review", label: "for_review", onClick: () => setSelectedState("for_review"), selected: selectedState === "for_review" },
        { id: "active", label: "active", onClick: () => setSelectedState("active"), selected: selectedState === "active" },
        { id: "archived", label: "archived", onClick: () => setSelectedState("archived"), selected: selectedState === "archived" },
    ];

    const addAdToProjectId = (projectId: string, clientId: string, organizationId: string, organizationName: string) => {
        ui.newAdChange({ projectId: projectId, clientId: clientId, organizationId: organizationId, organizationName: organizationName });
        setShowAddAd(true);
    }

    return (
        <div>
            <Overlay visible={false} />
            <ScreenHeader text="Annonser" icon={AdminIcons.ad} />
            <div>
                <ToolBar tools={tools} />
            </div>
            <hr />
            <div>
                <ToolBar tools={state_tools} />
            </div>
            {/* <div>
                {
                    ui.adProjectsAsList.map(n => (!!n.clientId ? n.clientId : "") + (!!n.organizationId ? n.organizationId : "") + " = ")
                }
            </div> */}
            {/* <div>
                <label>Projekt</label>
                <div className="taglist">
                    {ui.adProjectsAsList?.map(p => (
                        <span key={p?.id} className="tag">
                            {p?.name}
                            -
                            {uiClients.get(!!p?.clientId ? p?.clientId : p?.organizationId)?.name}
                        </span>
                    ))}
                </div>
            </div>
            <hr /> */}
            {/* <div>
                <ToolBarClean tools={state_tools} />
            </div> */}

            {/* <div>
                <div className="taglist">
                    {ui.allClientIdsUsed?.map(id => (
                        <span className={"tag" + (ui.clientSelected(id) ? " selected" : "")} key={id} onClick={() => { ui.clientsfFilterToggle(id); }}>
                            <span className="name">{uiClients.get(id)?.name}</span>
                        </span>
                    ))}
                </div>
            </div> */}

            <div>
                <table className="tbl tbl-ads">
                    <thead>
                        <tr>
                            <th>Status</th>
                            {/* <th>Annonsör</th> */}
                            <th>Namn</th>
                            <th>Typ</th>
                            <th>Period</th>
                            <th>Bild</th>
                            <th>Titel 1</th>
                            <th>Titel 2</th>
                            {/* <th>Titel 3</th> */}
                        </tr>
                    </thead>
                    <tbody>

                        {ui.adProjectsAsList?.map(proj => (
                            <ProjectRow
                                key={proj.id}
                                proj={proj}
                                addAdToProjectId={addAdToProjectId}
                                reloadList={(() => ui.loadWithState(selectedState))}
                            />
                        ))}

                        <tr>
                            <td colSpan={9}>
                                &nbsp;
                                <hr />
                                &nbsp;
                            </td>

                        </tr>

                        {selectedState !== "archived" && ui.allAdsIdWithoutProject?.filter(m => true)?.map(a => (
                            <Adrow
                                key={a}
                                id={a}
                                open={selectedId === a}
                                onRowClick={e => {
                                    if (selectedId === a) {
                                        setSelectedId(null);
                                    } else {
                                        setSelectedId(a);
                                    }
                                }}
                                reloadList={() => {
                                    ui.loadWithState(selectedState);
                                }}
                                project={null}
                            />
                        ))}

                        {selectedState === "archived" && ui.all?.filter(m => true)?.map(a => (
                            <Adrow
                                key={a}
                                id={a}
                                open={selectedId === a}
                                onRowClick={e => {
                                    if (selectedId === a) {
                                        setSelectedId(null);
                                    } else {
                                        setSelectedId(a);
                                    }
                                }}
                                reloadList={() => {
                                    ui.loadWithState(selectedState);
                                }}
                                project={null}
                            />
                        ))}
                    </tbody>
                </table>

            </div>

            {showAddAd && (
                <Dialog visible={showAddAd} title="Lägg till annons"
                    onOk={async () => {
                        await ui.newAdSave();
                        setShowAddAd(false);
                    }}
                    onCancel={() => {
                        ui.newAdClear();
                        setShowAddAd(false)
                    }}
                    okButtonText="Lägg till"
                    cancelButtonText="Ångra"
                    okDisabled={ui.newAdValid !== true}
                >
                    <div className="form-container">

                        <div className="form-item w100">
                            <label>
                                Namn
                            </label>
                            <input type="text" value={ui.newAdModel?.name} onChange={e => { ui.newAdChange({ name: e.target.value }) }} />
                        </div>

                        <div className="form-item w100">
                            <label>Annonsör</label>
                            <select
                                value={!!ui.newAdModel?.clientId ? ui.newAdModel?.clientId : ui.newAdModel?.organizationId}
                                data-selected={!!ui.newAdModel?.clientId ? ui.newAdModel?.clientId : ui.newAdModel?.organizationId}
                                onChange={e => {
                                    const opt = uiClients.get(e?.target.value);
                                    if (opt?.label === "organization") {
                                        ui.newAdChange({ clientId: null, organizationId: e.target.value, organizationName: opt?.name });
                                    } else {
                                        ui.newAdChange({ clientId: e.target.value, organizationId: null, organizationName: opt?.name });
                                    }
                                }}
                            >
                                <option key="">-</option>
                                {uiClients.all.map(option => {
                                    const opt = uiClients.get(option);
                                    const txt = opt?.label === "organization" ? "Org: " + opt?.name : "Klient: " + opt?.name;
                                    return (
                                        <option key={option} value={option}>
                                            {txt}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>

                        <div className="form-item w100">
                            <label>Projekt</label>
                            <select
                                value={ui.newAdModel?.projectId}
                                // data-selected={}
                                onChange={e => { ui.newAdChange({ projectId: e.target.value }); }}
                            >
                                <option key="">-</option>
                                {ui.adProjectsAsList.map(option => {
                                    return (
                                        <option key={option?.id} value={option?.id}>
                                            {option?.name}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>

                        <div className="form-item w100">
                            <div>
                                <label>Typ</label>
                                <div>
                                    {ui.adTypes?.map(t => (
                                        <CheckBoxWithLabel
                                            key={t}
                                            checked={ui.newAdTypes.indexOf(t) >= 0}
                                            optionName={t}
                                            onChange={e => {
                                                if (ui.newAdTypes.indexOf(e) >= 0) {
                                                    ui.setNewAdTypes(ui.newAdTypes.filter(m => m != e));
                                                } else {
                                                    ui.setNewAdTypes([...ui.newAdTypes, e]);
                                                }
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                            <div className="hidden">
                                <button className="btn" onClick={() => {
                                    ui.setNewAdTypes([
                                        "discovery_featured",
                                        "plantsearch",
                                        "plantdetail_main",
                                        "calendar_list",
                                        "offer"
                                    ])
                                }}>Litet</button>

                                <button className="btn" onClick={() => {
                                    ui.setNewAdTypes([
                                        "discovery_featured",
                                        "plantsearch",
                                        "plantdetail_main",
                                        "calendar_list",
                                        "offer",
                                        "plantdetail_main_web"
                                    ])
                                }}>Mellan</button>

                                <button className="btn" onClick={() => {
                                    ui.setNewAdTypes([
                                        "discovery_featured",
                                        "plantsearch",
                                        "plantdetail_main",
                                        "calendar_list",
                                        "offer",
                                        "plantdetail_main_web",
                                        "monthly_article"
                                    ])
                                }}>Stor</button>

                            </div>
                        </div>
                    </div>
                </Dialog>
            )}

            {showAddAdProject && (
                <>
                    <Dialog visible={showAddAdProject} title="Lägg till projekt"
                        onOk={async () => {
                            await ui.newAdProjectSave();
                            setShowAddAdProject(false);
                        }}
                        onCancel={() => {
                            ui.resetAdProjectSave();
                            setShowAddAdProject(false);
                        }}
                        okButtonText="Lägg till"
                        cancelButtonText="Ångra"
                        okDisabled={ui.newAdProjectValid !== true}
                    >
                        <div>
                            <div className="form-item w100">
                                <label>
                                    Namn
                                </label>
                                <input type="text" value={ui.newAdProjectModel?.name} onChange={e => { ui.newAdProjectChange({ name: e.target.value }) }} />
                            </div>

                            <div className="form-item w100">
                                <label>Annonsör</label>
                                <select
                                    value={!!ui.newAdProjectModel?.clientId ? ui.newAdProjectModel?.clientId : ui.newAdProjectModel?.organizationId}
                                    data-selected={!!ui.newAdProjectModel?.clientId ? ui.newAdProjectModel?.clientId : ui.newAdProjectModel?.organizationId}
                                    onChange={e => {
                                        const opt = uiClients.get(e?.target.value);
                                        if (opt?.label === "organization") {
                                            ui.newAdProjectChange({ clientId: null, organizationId: e.target.value, organizationName: opt?.name });
                                        } else {
                                            ui.newAdProjectChange({ clientId: e.target.value, organizationId: null, organizationName: opt?.name });
                                        }
                                    }}
                                >
                                    <option key="">-</option>
                                    {uiClients.all.map(option => {
                                        const opt = uiClients.get(option);
                                        const txt = opt?.label === "organization" ? "Org: " + opt?.name : "Klient: " + opt?.name;

                                        if (opt?.label !== "organization") { return (null) }

                                        return (
                                            <option key={option} value={option}>
                                                {txt}
                                            </option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                    </Dialog>
                </>
            )}

            {false && uiClients?.all?.map(n => (
                <div key={n}>
                    {n}:{uiClients.get(n)?.name}
                </div>
            ))}
        </div>
    )
}

const toPercent = (e: number) => {
    if (e) {
        const n = Math.round(e * 1000) / 10;
        return n + "%";
    }
    return "-";
}
const formatNumber = (e: number) => {
    if (e) {
        return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
    return "-";
}

const Adrow = ({ id, open, onRowClick, reloadList, project }: { id: string, open: boolean, onRowClick(e: string): void, reloadList(): void, project: AdProjectType }) => {
    const uiClients = useAdClients();
    const dh = useDateHelper();
    const ui = useAdAdmin();

    const item = ui.get(id);
    const dk = useDateHelper().currentDateKey();


    return (
        <>
            <tr onClick={() => onRowClick(id)} className={"tbl-expanded-row-toggler" + ((!!item?.archived || item?.adstate === "archived") ? " archived" : "")} data-id={id}>
                <td className={"adstate state-" + item?.adstate}>
                    <StateRenderer adstate={item?.adstate} />
                </td>
                {/* <td className="singlerow">
                    {uiClients.get(item?.clientId ?? item?.organizationId)?.name}
                </td> */}
                <td className="singlerow">
                    {item?.name}
                    {item?.num_views > 0 && (<span title={"Uppdaterat " + dh.timeAgo(item?.stats_updated_epoch)}>
                        &nbsp;-&nbsp;(v: {item?.num_views},c: {item?.num_press}, ctr: {toPercent(item?.num_press / item?.num_views)})
                    </span>)}
                </td>
                <td>
                    {item?.type}
                </td>
                <td>
                    {DateFormatter.dateKeyToDate(item?.startDateKey)} - {DateFormatter.dateKeyToDate(item?.endDateKey)}
                    {(dk >= item?.startDateKey && dk <= item?.endDateKey) && (
                        <span style={{
                            backgroundColor: "green",
                            width: "10px",
                            height: "10px",
                            borderRadius: "10px",
                            display: "inline-block",
                            marginLeft: "10px"
                        }}>
                        </span>
                    )}
                </td>
                <td>
                    {!!item?.imageUrl && (<AdminIcon icon={AdminIcons.images} />)}
                </td>
                <td className="singlerow">
                    {item?.title01}
                </td>
                <td className="singlerow">
                    {item?.title02}
                </td>
                {/* <td className="singlerow">
                    {item?.title03}
                </td> */}
            </tr>

            {open && (
                <>
                    <tr className={"tbl-expanded-row"}>
                        <td colSpan={9}>
                            <AdItemEditor id={id} reloadList={reloadList} project={project} />
                        </td>
                    </tr>
                    <tr />
                </>
            )}

        </>
    )

}


const AdItemEditor = ({ id, reloadList, project }: { id: string, reloadList(): void, project: AdProjectType }) => {
    const editor = useAdItemEditor(id, reloadList);
    const ui = useAdAdmin();
    const dh = useDateHelper();

    const [selectPlantsDialogVisible, setSelectPlantsDialogVisible] = useState<boolean>(false)

    const plantDb = usePlant();

    return (
        <div className={"ad-item-editor" + ((!!editor?.item?.archived || editor?.item?.adstate === "archived") ? " archived" : "")}>
            <h3>

                {!!editor?.item?.archived && (
                    <span>&nbsp;(Arkiverad annons)</span>
                )}
            </h3>
            {(editor?.item?.num_views > 0) && (<div className="stats">
                Visningar: {formatNumber(editor?.item?.num_views ?? 0)} st,
                Klick: {formatNumber(editor?.item?.num_press ?? 0)} st,
                Användare (visa): {formatNumber(editor?.item?.num_users_view ?? 0)} st,
                Användare (klick): {formatNumber(editor?.item?.num_users_press ?? 0)} st,
                CTR: {editor?.item?.num_views > 0 ? toPercent(editor?.item?.num_press / editor?.item?.num_views) : "-"},
                (Uppdaterat {dh.timeAgo(editor?.item?.stats_updated_epoch)})
            </div>)}

            <div className="props">

                {/* Text */}
                <div>
                    <EditStringInput title={"Namn"} defaultValue={editor.item?.name ?? ""} onChange={e => { editor.edit({ name: e }) }} />
                    <EditStringInput title={"Titel 1"} defaultValue={editor.item?.title01 ?? ""} onChange={e => { editor.edit({ title01: e }) }} />
                    <EditStringInput title={"Titel 2"} defaultValue={editor.item?.title02 ?? ""} onChange={e => { editor.edit({ title02: e }) }} />
                    <EditStringInput title={"Titel 3"} defaultValue={editor.item?.title03 ?? ""} onChange={e => { editor.edit({ title03: e }) }} />
                    <EditStringInput title={"Titel 4"} defaultValue={editor.item?.title04 ?? ""} onChange={e => { editor.edit({ title04: e }) }} />
                    <EditStringInput title={"Titel 5"} defaultValue={editor.item?.title05 ?? ""} onChange={e => { editor.edit({ title05: e }) }} />
                </div>

                {/* Links & Images */}
                <div>
                    <EditStringInput title={"Kundnamn annons"} defaultValue={editor.item?.organizationName ?? ""} onChange={e => { editor.edit({ organizationName: e?.trim() }) }} />
                    <EditStringInput title={"Länk (inkl https://)"} defaultValue={editor.item?.link ?? ""} onChange={e => { editor.edit({ link: e?.trim() }) }} />
                    <EditStringInput title={"Länktext"} defaultValue={editor.item?.linkText ?? ""} onChange={e => { editor.edit({ linkText: e }) }} />
                    <EditStringInput title={"Bild url (inkl https://)"} defaultValue={editor.item?.imageUrl ?? ""} onChange={e => { editor.edit({ imageUrl: e?.trim() }) }} />


                    {/* plantdetail_main */}
                    <div>
                        <div className="form-item w100" hidden={editor?.item?.type != "plantdetail_main"}>
                            <label>
                                Valda växter
                            </label>

                            <button className="btn select-plants-btn" onClick={e => { setSelectPlantsDialogVisible(true); }}>
                                Välj
                            </button>
                            <div>
                                {(!!editor.item?.plantIds) && editor.getItemPlantIds().map(pid => {
                                    const p = plantDb.item(pid);
                                    return (
                                        <div className="selected-plant-tag" key={pid}>
                                            {p?.fields?.name}
                                            {p?.fields?.specifictype}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <SelectPlantsDialog
                            visible={selectPlantsDialogVisible}
                            preSelected={editor.item?.plantIds?.split(';')}
                            onPlantsSelected={(e: string[]) => {

                                if (e == null) { // cancel
                                    setSelectPlantsDialogVisible(false);
                                    console.log("cancel");
                                }
                                if (e?.length >= 0) { // ok
                                    setSelectPlantsDialogVisible(false);
                                    editor.edit({ plantIds: e.join(';') })
                                    console.log(e);
                                }
                            }} />
                    </div>
                </div>

                {/* Annonsör */}
                <div>
                    {/* 
                    <div className="form-item w100">
                        <label>
                            Annonsör
                        </label>
                        <select
                            value={editor.item?.clientId}
                            onChange={(e) => { editor.edit({ clientId: e.target.value }); }}                            >
                            <option key="">-</option>
                            {editor.allClients.map(option => (
                                <option key={option?.id} value={option?.id}>{option?.name}</option>
                            ))}
                        </select>
                    </div> */}

                    <div className="form-item w100">
                        <label>
                            Typ
                        </label>
                        <select
                            value={editor.item?.type}
                            onChange={(e) => { editor.edit({ type: e.target.value as AdItemTypeType }); }}                            >
                            <option key="">-</option>
                            {editor.adTypes.map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </select>
                    </div>

                    <EditDateKeyInput title={"StartDatum"} defaultValue={editor.item?.startDateKey} onChange={e => { editor.edit({ startDateKey: e }) }}
                        minDateKey={project?.startdatekey} maxDateKey={project?.enddatekey} />
                    <EditDateKeyInput title={"SlutDatum"} defaultValue={editor.item?.endDateKey} onChange={e => { editor.edit({ endDateKey: e }) }}
                        minDateKey={project?.startdatekey} maxDateKey={project?.enddatekey} />

                    {/* <EditStringInput title={"Projektnamn"} defaultValue={editor.item?.adGroupName} onChange={e => { editor.edit({ adGroupName: e }) }} suggestions={editor.adGroupNames?.[editor.item?.clientId]} /> */}


                    <div className="form-item w100">
                        <label>
                            Projekt
                        </label>
                        <select
                            value={editor.item?.projectId}
                            onChange={(e) => { editor.edit({ projectId: e.target.value }); }}                            >
                            <option key="">-</option>
                            {ui.adProjectsAsList?.filter(m => m?.organizationId == editor?.item?.organizationId || m?.clientId == editor?.item?.clientId).map(option => (
                                <option key={option?.id} value={option?.id}>{option?.name}</option>
                            ))}
                        </select>
                    </div>

                    {/* 
                    <div className="form-item w100">
                        <label>
                            Status
                        </label>
                        <select
                            value={editor.item?.adstate}
                            onChange={(e) => { editor.edit({ adstate: e.target.value as AdStateType }); }}                            >
                            <option key="">-</option>
                            {editor.adStates.map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </select>
                    </div> */}

                </div>

                {/* Kopplad bild */}
                <div>

                    <UploadImageToAdElement
                        id={editor.item?.id}
                        onFileUploaded={reloadList}
                    />

                    <h4>Kopplad bild</h4>
                    <img src={editor?.item?.imageUrl} loading="lazy" />
                </div>

                {/* Tools */}
                <div>
                    <ToolBarClean
                        tools={[
                            // {
                            //     id: "publish",
                            //     label: (editor?.item?.published ? "Avpublicera" : "Publicera"),
                            //     onClick: async () => {
                            //         if (editor?.item?.published) {
                            //             editor.togglePublish(editor?.item?.id, false);
                            //         } else {
                            //             editor.togglePublish(editor?.item?.id, true);
                            //         }
                            //     },
                            //     icon: AdminIcons.save,
                            //     hidden: !!editor?.item?.archived
                            // },
                            { id: "save", label: "Spara", onClick: editor.save, icon: AdminIcons.save, disabled: !editor.changed, hidden: !!editor?.item?.archived },
                            {
                                id: "delete", label: "Radera", onClick: async () => {
                                    const conf = MessageBoxes.confirm("Radera '" + editor?.item?.name + "'");
                                    if (conf) {
                                        const success = await editor.delete(editor?.item?.id);
                                    }
                                }, icon: AdminIcons.trashcan,
                                hidden: !!editor?.item?.archived
                            },
                            {
                                id: "archive",
                                label: (editor?.item?.archived ? "Ta ur arkiv" : "Arkivera"),
                                onClick: async () => {
                                    if (!!editor?.item?.archived) {
                                        editor.toggleArchived(editor?.item?.id, false);
                                    } else {
                                        editor.toggleArchived(editor?.item?.id, true);
                                    }
                                },
                                icon: AdminIcons.save,
                            },
                        ]}
                    />
                </div>
            </div>
        </div>
    )
}

const CheckBoxWithLabel = ({ checked, optionName, onChange, label }: { checked: boolean, optionName: AdItemTypeType, onChange(e: AdItemTypeType): void, label?: string }) => {

    return (
        <div className="checkbox-with-label">
            <input checked={checked} id={optionName} type={"checkbox"} name="type" onChange={() => onChange(optionName)} />
            <label htmlFor={optionName}>{label ?? optionName}</label>
        </div>
    )
}


const CheckBoxWithLabelBase = ({ checked, id, onChange, label }: { checked: boolean, id: string, onChange(e: boolean): void, label?: string }) => {

    return (
        <div className="checkbox-with-label">
            <input checked={checked} id={id} type={"checkbox"} name="type" onChange={(e) => onChange(e.target.checked)} />
            <label htmlFor={id}>{label}</label>
        </div>
    )
}

type StatsType = {
    num_views?: number,
    num_press?: number,
    num_users_view?: number,
    num_users_press?: number,
    stats_updated_epoch?: number
}
const ProjectRow = ({ proj, addAdToProjectId, reloadList }: { proj: AdProjectType, addAdToProjectId(projectId: string, clientId: string, organization: string, organizationName: string): void, reloadList(): void }) => {

    // Ensure clients
    const uiClients = useAdClients();
    useEffect(() => {
        uiClients.load();

        console.log("ProjectRow.useEffect.[]:", proj?.name);
    }, []);

    const dh = useDateHelper();

    const ui = useAdAdmin();
    const [selectedId, setSelectedId] = useState<string>(null);

    const [ads, setAds] = useState<AdItemType[]>([]);
    useEffect(() => {
        if (!!ui.all && ui.all?.length > 0) {
            const _ads = ui.all?.filter(aid => ui.get(aid)?.projectId === proj?.id)?.map(aid => ui.get(aid));
            setAds(_ads);
        }
    }, [, ui.all]);

    const startDateKey = Math.min.apply(Math, ads?.map(e => e.startDateKey));
    const endDateKey = Math.max.apply(Math, ads?.map(e => e.endDateKey));

    const [editing, setEditing] = useState<boolean>(false);
    const [editingModel, setEditingModel] = useState<AdProjectType>(undefined);

    const updateModel = (e: AdProjectType) => {
        const r = { ...editingModel, ...e };
        setEditingModel(r);
        console.log("updateModel:", r);
    }


    useEffect(() => {
        if (editing) {
            setEditingModel({ ...proj });
        } else {
            setEditingModel(undefined);
        }
    }, [, editing]);

    const onSaveProject = async () => {
        const _n = { ...editingModel };
        await ui.adProjectUpdate(_n);
        setEditing(false);
    }

    const onUpdateProjectType = async (e: AdStateType) => {
        await ui.onUpdateProjectType(proj?.id, e);
        setEditing(false);
    }

    const [stats, setStats] = useState<StatsType>({});
    useEffect(() => {
        if (!!ads) {
            console.log("calc stats....");
            let d: StatsType = { num_views: 0, num_press: 0, num_users_view: 0, num_users_press: 0 };
            ads.forEach(a => {
                if (a.num_views > 0) { d.num_views += a.num_views; }
                if (a.num_press > 0) { d.num_press += a.num_press; }
                if (a.num_users_view > 0) { d.num_users_view += a.num_users_view; }
                if (a.num_users_press > 0) { d.num_users_press += a.num_users_press; }
                if (a.stats_updated_epoch > 0) { d.stats_updated_epoch = a.stats_updated_epoch; }
            });

            if (proj.hasinstagramstory === true) {
                d.num_views += (proj?.instagramstory_num_views ?? 0);
                d.num_press += (proj?.instagramstory_num_press ?? 0);
                d.num_users_view += (proj?.instagramstory_num_views ?? 0);
                d.num_users_press += (proj?.instagramstory_num_press ?? 0);
            }

            if (proj.hasinstagrampost === true) {
                d.num_views += (proj?.instagrampost_num_views ?? 0);
                d.num_press += (proj?.instagrampost_num_press ?? 0);
                d.num_users_view += (proj?.instagrampost_num_views ?? 0);
                d.num_users_press += (proj?.instagrampost_num_press ?? 0);
            }

            if (proj.hassponsoredpost === true) {
                d.num_views += (proj?.sponsoredpost_num_views ?? 0);
                d.num_press += (proj?.sponsoredpost_num_press ?? 0);
                d.num_users_view += (proj?.sponsoredpost_num_views ?? 0);
                d.num_users_press += (proj?.sponsoredpost_num_press ?? 0);
            }

            if (proj.hassponsoredblog === true) {
                d.num_views += (proj?.sponsoredblog_num_views ?? 0);
                d.num_press += (proj?.sponsoredblog_num_press ?? 0);
                d.num_users_view += (proj?.sponsoredblog_num_views ?? 0);
                d.num_users_press += (proj?.sponsoredblog_num_press ?? 0);
            }

            if (proj.haspushnotification === true) {
                d.num_views += (proj?.pushnotification_num_views ?? 0);
                d.num_press += (proj?.pushnotification_num_press ?? 0);
                d.num_users_view += (proj?.pushnotification_num_views ?? 0);
                d.num_users_press += (proj?.pushnotification_num_press ?? 0);
            }

            setStats(d);
        }
    }, [, ads, proj]);


    return (
        <React.Fragment key={proj.id}>
            <tr>
                <td colSpan={9}>

                    <div className="grp-row">
                        <div className="grp-name">
                            Kund: {uiClients.get(!!proj.clientId ? proj.clientId : proj.organizationId)?.name} -
                            Projekt: {proj.name}
                        </div>

                        <div className="grp-end">
                            State: <StateRenderer adstate={proj?.adstate} />
                        </div>

                        {/* <div className="grp-end">
                            <AdminIcon icon={AdminIcons.chart} />
                        </div> */}

                        <div className="actions">
                            <button className="btn" onClick={() => addAdToProjectId(proj.id, proj.clientId, proj.organizationId, proj?.organizationName)}>
                                <AdminIcon icon={AdminIcons.plus} />
                            </button>
                        </div>
                    </div>

                    {!editing && (<div className="grp-editor">

                        {/* Dates */}
                        <div>
                            <div>
                                <span className="bolder">Start: </span>
                                {DateFormatter.dateKeyToDate(proj?.startdatekey)}
                            </div>
                            <div>
                                <span className="bolder">Slut: </span>
                                {DateFormatter.dateKeyToDate(proj?.enddatekey)}
                            </div>
                            <div>
                                <span className="bolder">Deadline: </span>
                                {DateFormatter.dateKeyToDate(proj?.deadlinedatekey)}
                            </div>

                        </div>

                        {/* Insta */}
                        <div>
                            <div>
                                <span className="bolder">InstagramPost: </span>
                                {proj.hasinstagrampost ? "JA" : "NEJ"}
                            </div>
                            <div>
                                <span className="bolder">InstagramStory: </span>
                                {proj.hasinstagramstory ? "JA" : "NEJ"}
                            </div>
                            <div>
                                <span className="bolder">PushNotification: </span>
                                {proj.haspushnotification ? "JA" : "NEJ"}
                            </div>
                        </div>

                        {/* Insta 2 */}
                        <div>
                            <div>
                                <span className="bolder">SponsoredBlog: </span>
                                {proj.hassponsoredblog ? "JA" : "NEJ"}
                            </div>
                            <div>
                                <span className="bolder">SponsoredPost: </span>
                                {proj.hassponsoredpost ? "JA" : "NEJ"}
                            </div>
                        </div>

                        {/* Misc */}
                        <div>
                            <div>
                                <span className="bolder">Kundnamn annons: </span>
                                {proj.organizationName}
                            </div>
                            <div>
                                <span className="bolder">Paketnamn: </span>
                                {proj.packagename}
                            </div>
                            <div>
                                <span className="bolder">Pris: </span>
                                {proj.price}
                            </div>
                            <div>
                                <span className="bolder">Visningar (mål): </span>
                                {formatNumber(proj.targetviews)}
                            </div>
                        </div>

                        {/* Buttons */}
                        <div>

                            {(stats?.stats_updated_epoch > 0 && stats?.num_views > 0) && (
                                <div>
                                    <div>Visningar:{formatNumber(stats?.num_views)}</div>
                                    <div>Klick:{formatNumber(stats?.num_press)}</div>
                                    {proj?.targetviews > 0 && (
                                        <div>Måluppfyllelse:{toPercent(stats?.num_views / proj?.targetviews)}</div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div>
                            {(stats?.stats_updated_epoch > 0 && stats?.num_views > 0) && (
                                <div>
                                    <div>Användare visat:{formatNumber(stats?.num_users_view)}</div>
                                    <div>Användare klickat:{formatNumber(stats?.num_users_press)}</div>
                                    <div title={dh.epochToDateTime(stats?.stats_updated_epoch)}>uppdaterad:{dh.timeAgo(stats?.stats_updated_epoch)}</div>
                                </div>
                            )}
                        </div>

                        <div>
                            <button className="btn btn-noborder" onClick={() => setEditing(!editing)}>
                                <AdminIcon icon={AdminIcons.pen} />
                            </button>
                        </div>
                    </div>)}


                    {editing && (
                        <div className="grp-editor">
                            {/* Dates */}
                            <div>
                                <div>
                                    <EditDateKeyInput
                                        title={"StartDatum"}
                                        defaultValue={editingModel?.startdatekey}
                                        onChange={e => { updateModel({ startdatekey: e }) }}
                                    />
                                </div>
                                <div>
                                    <EditDateKeyInput
                                        title={"SlutDatum"}
                                        defaultValue={editingModel?.enddatekey}
                                        onChange={e => { updateModel({ enddatekey: e }) }}
                                    />
                                </div>
                                <div>
                                    <EditDateKeyInput
                                        title={"Deadline"}
                                        defaultValue={editingModel?.deadlinedatekey}
                                        onChange={e => { updateModel({ deadlinedatekey: e }) }}
                                    />
                                </div>

                            </div>

                            {/* Insta */}
                            <div>
                                <div>
                                    <EditCheckbox
                                        title={"InstagramPost"}
                                        defaultValue={editingModel?.hasinstagrampost}
                                        onChange={e => { updateModel({ hasinstagrampost: e }) }}
                                    />
                                    <EditViewsClicks hidden={!editingModel?.hasinstagrampost}
                                        numViews={editingModel?.instagrampost_num_views}
                                        numPress={editingModel?.instagrampost_num_press}
                                        onNumViewsChange={e => updateModel({ instagrampost_num_views: e })}
                                        onNumPressChange={e => updateModel({ instagrampost_num_press: e })}
                                    />
                                </div>
                                <div>
                                    <EditCheckbox
                                        title={"InstagramStory"}
                                        defaultValue={editingModel?.hasinstagramstory}
                                        onChange={e => { updateModel({ hasinstagramstory: e }) }}
                                    />
                                    <EditViewsClicks hidden={!editingModel?.hasinstagramstory}
                                        numViews={editingModel?.instagramstory_num_views}
                                        numPress={editingModel?.instagramstory_num_press}
                                        onNumViewsChange={e => updateModel({ instagramstory_num_views: e })}
                                        onNumPressChange={e => updateModel({ instagramstory_num_press: e })}
                                    />
                                </div>
                                <div>
                                    <EditCheckbox
                                        title={"PushNotification"}
                                        defaultValue={editingModel?.haspushnotification}
                                        onChange={e => { updateModel({ haspushnotification: e }) }}
                                    />
                                    <EditViewsClicks hidden={!editingModel?.haspushnotification}
                                        numViews={editingModel?.pushnotification_num_views}
                                        numPress={editingModel?.pushnotification_num_press}
                                        onNumViewsChange={e => updateModel({ pushnotification_num_views: e })}
                                        onNumPressChange={e => updateModel({ pushnotification_num_press: e })}
                                    />
                                </div>
                            </div>

                            {/* Insta 2 */}
                            <div>
                                <div>
                                    <EditCheckbox
                                        title={"SponsoredBlog"}
                                        defaultValue={editingModel?.hassponsoredblog}
                                        onChange={e => { updateModel({ hassponsoredblog: e }) }}
                                    />
                                    <EditViewsClicks hidden={!editingModel?.hassponsoredblog}
                                        numViews={editingModel?.sponsoredblog_num_views}
                                        numPress={editingModel?.sponsoredblog_num_press}
                                        onNumViewsChange={e => updateModel({ sponsoredblog_num_views: e })}
                                        onNumPressChange={e => updateModel({ sponsoredblog_num_press: e })}
                                    />
                                </div>
                                <div>
                                    <EditCheckbox
                                        title={"SponsoredPost"}
                                        defaultValue={editingModel?.hassponsoredpost}
                                        onChange={e => { updateModel({ hassponsoredpost: e }) }}
                                    />
                                    <EditViewsClicks hidden={!editingModel?.hassponsoredpost}
                                        numViews={editingModel?.sponsoredpost_num_views}
                                        numPress={editingModel?.sponsoredpost_num_press}
                                        onNumViewsChange={e => updateModel({ sponsoredpost_num_views: e })}
                                        onNumPressChange={e => updateModel({ sponsoredpost_num_press: e })}
                                    />
                                </div>
                            </div>

                            {/* Misc */}
                            <div>
                                <div>
                                    <EditStringInput
                                        title={"Kundnamn annons"}
                                        defaultValue={editingModel?.organizationName}
                                        onChange={e => { updateModel({ organizationName: e }) }}
                                    />
                                </div>
                                <div>
                                    <EditStringInput
                                        title={"Packagename"}
                                        defaultValue={editingModel?.packagename}
                                        onChange={e => { updateModel({ packagename: e }) }}
                                    />
                                </div>
                                <div>
                                    <EditNumberInput
                                        title={"Pris"}
                                        defaultValue={editingModel?.price}
                                        onChange={e => { updateModel({ price: e }) }}
                                    />
                                </div>
                                <div>
                                    <EditNumberInput
                                        title={"Visningar (mål)"}
                                        defaultValue={editingModel?.targetviews}
                                        onChange={e => { updateModel({ targetviews: e }) }}
                                    />
                                </div>
                            </div>

                            {/* Buttons */}
                            <div>

                                <button className={"btn btn-toggle" + (proj?.adstate === "active" ? " pressed" : "")} onClick={() => onUpdateProjectType("active")}>
                                    active
                                </button>

                                <button className={"btn btn-toggle" + (proj?.adstate === "for_review" ? " pressed" : "")} onClick={() => onUpdateProjectType("for_review")}>
                                    for_review
                                </button>

                                <button className={"btn btn-toggle" + (proj?.adstate === "draft" ? " pressed" : "")} onClick={() => onUpdateProjectType("draft")}>
                                    draft
                                </button>

                                <button className={"btn btn-toggle" + (proj?.adstate === "archived" ? " pressed" : "")} onClick={() => onUpdateProjectType("archived")}>
                                    archived
                                </button>

                            </div>

                            <div></div>

                            <div>
                                <button className="btn" onClick={() => onSaveProject()}>
                                    Spara <AdminIcon icon={AdminIcons.save} />
                                </button>

                                <button className="btn" onClick={() => setEditing(false)}>
                                    Avbryt <AdminIcon icon={AdminIcons.close} />
                                </button>
                            </div>
                        </div>)}
                </td>
            </tr>

            {ads.map(m => m?.id).map(aid => {

                return (
                    <Adrow
                        key={aid}
                        id={aid}
                        open={selectedId === aid}
                        onRowClick={e => {
                            if (selectedId === aid) {
                                setSelectedId(null);
                            } else {
                                setSelectedId(aid);
                            }
                        }}
                        reloadList={reloadList}
                        project={proj}
                    />
                )
            })}


        </React.Fragment>
    )


}

const StateRenderer = ({ adstate }: { adstate: AdStateType }) => {
    return (
        <span>
            {adstate === "active" && (<AdminIcon icon={AdminIcons.checkbox_checked} />)}
            {adstate === "draft" && (<AdminIcon icon={AdminIcons.pen} />)}
            {adstate === "for_review" && (<AdminIcon icon={AdminIcons.search} />)}
            {adstate}
        </span>
    )
}